import React from 'react'
import { Video, VideoContentType } from '@islandsstofa/react'

export default ({ content: video }: { content: VideoContentType }) => (
  <div className='modal-template__add-some-pad mt-3 d-flex flex-column w-100'>
    <Video autoplay video={video} />
  </div>
)
